var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    id: "icon-weatherarrow",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.761,8.973l1.737,1.736V1.548C6.499,0.693,7.192,0,8.047,0c0.855,0,1.548,0.693,1.548,1.548v9.161 l1.736-1.736c0.605-0.605,1.587-0.605,2.19,0c0.606,0.605,0.606,1.586,0,2.189l-4.381,4.383c-0.604,0.604-1.585,0.604-2.19,0 l-4.38-4.383c-0.604-0.604-0.604-1.584,0-2.189C3.176,8.367,4.156,8.367,4.761,8.973z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherArrow);
export default __webpack_public_path__ + "static/media/weatherArrow.7b64f50e34b9dfb5d72b7a28c8bccdad.svg";
export { ForwardRef as ReactComponent };